
import Vue from "vue";

import ImageSizePicker, {SupportedFormat} from "./image-size-picker.vue";

export const defaultAndroidOutputFormatOptions: SupportedFormat[] = [
  { key: 'auto', name: "Auto", description: "Auto - xml vector drawable, png or jpg" },
  { key: 'png', name: "PNG", description: "PNG - rasterize vector images" },
  { key: 'jpg', name: "JPEG", description: "JPEG - rasterize vector images" },
  { key: 'webp', name: "WebP", description: "WebP - rasterize vector images" },
];

export default Vue.extend({
  name: "android-image-size-picker",
  components: { ImageSizePicker },
  props: {
    sizes: {
      type: Array,
      required: true,
    },
    editable: {
      type: Boolean,
      required: false,
      default: () => true,
    },
  },
  data() {
    return {
      outputFormatOptions: defaultAndroidOutputFormatOptions
    };
  }
})
